import { Box, Button, Divider, Stack, Tooltip, Typography } from "@mui/material";
import { Notificationicon } from "../../assets/svgicons";
import { useQuery } from "react-query";
import API from "../../util/api";
import { useSelector } from "react-redux";
import { Notification } from "./notification-item";
import { Fragment, useMemo } from "react";

const getNotifications = async (token) => {
  return await API.get("/api/notifications", {
    params: { rows: 5 },
    headers: { Authorization: `Bearer ${token}` },
  });
};

export const NotificationMenu = ({ onModalDisplay, notificationData, notificationLoading, markAllAsReadMutation }) => {
  const token = useSelector((state) => state.auth.authToken);

  // const { data, isFetching } = useQuery(
  //   "latest-notifications",
  //   () => getNotifications(token),
  //   {
  //     refetchOnWindowFocus: false,
  //     staleTime: 5 * 60 * 1000,
  //     cacheTime: 5 * 60 * 1000
  //   },
  // );

  const notifications = useMemo(() => {
    // Safely access notificationData array, default to []
    const data = notificationData ?? [];
    // Take the first 5 notifications
    return data.slice(0, 5);
  }, [notificationData]); // ensure this is always an array
  const hasNewNotifications = notificationData?.length > 0;

  return (
    <li className="nav-item dropdown">
      <Tooltip title="Notifications" sx={{ position: "relative" }}>
        <Box
          id="notificationDropdown"
          data-toggle="dropdown" // Bootstrap 5 uses data-bs-toggle
          aria-expanded="false"
          sx={{
            width: 35,
            height: 35,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            borderRadius: "50%",
            boxShadow: "0px 2px 8px rgb(206 206 206 / 45%)",
            cursor: "pointer",
            position: "relative",
            flexShrink: 0,
            ml: 2
          }}
        >
          <Notificationicon width={18} />
          {hasNewNotifications && (
            <Box
              sx={{
                width: 5,
                height: 5,
                borderRadius: "50%",
                backgroundColor: "#bd2526",
                position: "absolute",
                top: 10,
                right: 10,
              }}
            />
          )}
        </Box>
      </Tooltip>

      <ul
        className="dropdown-menu dropdown-menu-end navbar-dropdown preview-list"
        aria-labelledby="notificationDropdown"
        style={{ minWidth: "400px", top: "120%", overflow: "hidden" }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          sx={{
            height: "40px",
            px: 2,
            borderBottom: "1px solid #ebedf2",
          }}
        >
          {/* Left side */}
          <Typography variant="subtitle1">Notifications</Typography>

          {/* Right side (grouped buttons) */}
          <Stack direction="row" spacing={1}>
            {notificationData?.length > 0 && (
              <Button
                variant="text"
                onClick={() => {
                  markAllAsReadMutation.mutate();
                }}
                sx={{
                  py: 0.5,
                  fontSize: "12px",
                  color: "rgb(189 37 38)",
                  textTransform: "none",
                  fontWeight: 600,
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "rgb(189 37 38)",
                  },
                }}
              >
                Clear All
              </Button>
            )}

            {notificationData?.length > 5 && (
              <Button
                variant="text"
                onClick={onModalDisplay}
                sx={{
                  px: 1,
                  py: 0.5,
                  fontSize: "12px",
                  color: "rgba(77, 85, 101, 0.8)",
                  textTransform: "none",
                  backgroundColor: "transparent",
                  "&:hover": {
                    backgroundColor: "transparent",
                    color: "rgba(77, 85, 101, 1)",
                  },
                }}
              >
                View All
              </Button>
            )}
          </Stack>
        </Stack>

        <Stack sx={{ maxHeight: 275, overflowY: "auto" }} onClick={(e) => e.stopPropagation()}>
          {notificationLoading ? (
            <div style={{ padding: 10 }}>Loading...</div>
          ) : notifications.length > 0 ? (
            notifications.map((item, index, array) => (
              <Fragment key={item.id}>
                <Notification data={item} />
                {index !== array.length - 1 && (
                  <Divider
                    sx={{
                      width: "calc(100% - 20px)",
                      mx: "10px",
                      borderStyle: "dashed",
                    }}
                  />
                )}
              </Fragment>
            ))
          ) : (
            <Typography sx={{ p: 2 }} variant="body2">
              No notifications
            </Typography>
          )}
        </Stack>
      </ul>
    </li>
  );
};
